import { render, staticRenderFns } from "./ot-contract-users-index.vue?vue&type=template&id=0b6edc41&scoped=true&"
import script from "./ot-contract-users-index.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-users-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-users-index.vue?vue&type=style&index=0&id=0b6edc41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6edc41",
  null
  
)

export default component.exports